module.exports = __webpack_public_path__ + "img/rede_logica.813cf279.svg";